import { combineReducers } from "redux";
import { persistReducer, createTransform } from "redux-persist";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";
import fieldReducer from "./fieldReducer";
import userReducer from "./userReducer";
import wellTestReducer from "./wellTestReducer";
import { parse, stringify } from "flatted";

export const transformCircular = createTransform(
  (inboundState) => stringify(inboundState),
  (outboundState) => parse(outboundState)
);

const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: ["field", "user", "wellTest"],
  transforms: [transformCircular],
};

const StaffSessionPersistConfig = { key: "user", storage: storageSession };

const rootReducer = combineReducers({
  field: (StaffSessionPersistConfig, fieldReducer),
  user: persistReducer(StaffSessionPersistConfig, userReducer),
  wellTest: (StaffSessionPersistConfig, wellTestReducer),
});

export default persistReducer(persistConfig, rootReducer);
